namespace TabAurous.Inventory {
    export interface GetLineNoResponse extends Serenity.ServiceResponse {
        Line_No?: number;
    }
}
